import App from './App.svelte';
import config from './config';

const blockTemplates = [
	{
		"file":"1x1x1.png",
		"offX":0,
		"dimensions": [1,1,1]
	},
	{
		 "file":"1x1x2.25.png",
		 "offX":0,
		"dimensions": [1,1,2.25]
	},
	{
		"file":"1x2x3.png",
		"offX":9,
		"dimensions": [1,2,3]
	},
	{
		"file":"2x2x2.png",
		"offX":0,
		"dimensions": [2,2,2]
	},
	{
		 "file":"2x2x3.png",
		 "offX":0,
		"dimensions": [2,2,3]
	},
	{
		"file":"2x2x6.png",
		"offX":0,
		"dimensions": [2,2,6]
 },
	{
		 "file":"2x4x3.5.png",
		 "offX":18,
		"dimensions": [2,4,3.5]
	}
]

const app = new App({
	target: document.body,
	props: {
		blockTemplates,
		config
	}
});

export default app;